import lang from "@/views/modules/ReportAuths/language/en";
import breadcrumbs from "@/views/modules/ReportAuths/MenuList.vue";

export default {
    name: "list-report-auths",
  
    components: {
        breadcrumbs,
    },
    data() {
        return {
            lang: [],
            filterData: {},
        }
    },
    mounted() {
        this.lang = lang;
    },
    methods: {
        clearFilters() {
            this.filterData = {};
        },
    }
}